import React, { useEffect, useState } from "react";
import axios from "axios";
import Box from "@mui/joy/Box";
import Mapa from "./mapaaventura.jsx";
import Grid from "@mui/joy/Grid";
import Tarjeta from "./tarjetas";
import Filtros from "./filtros";
import { useNavigate } from "react-router-dom";

export default function Disenoaventuras() {
  const navigate = useNavigate();

  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;

  let [latitud, setlatitud] = React.useState(0);
  let [longitud, setlongitud] = React.useState(0);
  let [zoom, setzoom] = React.useState(0);

  /* RECOGIENDO AVENTURAS */
  const [aventuras, setaventuras] = React.useState([]);

  useEffect(() => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let callaventuras = async () => {
        let aventuras = await axios.get(`${url}/api/aventuras`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setaventuras(aventuras.data);
      };
      callaventuras();
    } catch (err) {
      console.log("tenemos un error recogiendo aventuras");
    }
  }, []);
  /* RECOGIENDO AVENTURAS */

  /* FILTRO  CATEGORIAS */

  let [categoria, setcategoria] = React.useState("Todas");
  let [nivel, setnivel] = React.useState("Todos");
  let [pais, setpais] = React.useState("");
  let [ciudad, setciudad] = React.useState("");

  /* FILTRO  CATEGORIAS */

  let ubicarAventuraenMapa = (longitud, latitud) => {
    setlatitud(latitud);
    setlongitud(longitud);
    setzoom(12);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Centra horizontalmente
        justifyContent: "center", // Centra verticalmente
        height: "100vh", // Ocupa toda la altura de la pantalla
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          flexGrow: 1,
          height: "100%", // Esto hace que el grid ocupe todo el espacio disponible
          paddingTop: "50px",
          paddingBottom: "50px",
          paddingLeft: "0px",
          paddingRight: "0px",
          width: "80%",
        }}
      >
        <Grid
          xs={12}
          md={5}
          sx={{
            height: "100%", // Hace que la columna ocupe toda la altura disponible
            overflowY: "auto", // Activa el scroll si el contenido excede la altura
            paddingRight: 2,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "grid",
              alignItems: "center",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Filtros
              setCategoriaSeleccioanda={setcategoria}
              setNivelSeleccionado={setnivel}
              setpaisseleccionado={setpais}
              setciudadseleccionada={setciudad}
            />

            {aventuras
              .filter((elementofiltrado) => {
                // Filtro por categoría
                const cumpleCategoria =
                  categoria === "Todas" ||
                  elementofiltrado.categoria === categoria;

                // Filtro por nivel
                const cumpleNivel =
                  nivel === "Todos" || elementofiltrado.nivel === nivel;

                // Filtro por país
                const cumplePais =
                  pais === "" || elementofiltrado.pais === pais;

                // Filtro por ciudad
                const cumpleCiudad =
                  ciudad === "" || elementofiltrado.ciudad === ciudad;

                return (
                  cumpleCategoria && cumpleNivel && cumplePais && cumpleCiudad
                );
              })
              .map((valor, index) => {
                let colorchip = (nivel) => {
                  if (nivel === "Principiante") {
                    return "success";
                  } else if (nivel === "Intermedio") {
                    return "warning";
                  } else if (nivel === "Avanzado") {
                    return "danger";
                  } else {
                    return "gray";
                  }
                };
                let fechaFormato = new Date(valor.fecha);
                return (
                  <Tarjeta
                    titulo={valor.titulo}
                    descripcion={valor.descripcion}
                    ubicacion={valor.ubicacion}
                    categoria={valor.categoria}
                    nivel={valor.nivel}
                    imagen={`${linkimagen}/uploads/` + valor.imagen}
                    colornivel={colorchip(valor.nivel)}
                    latitud={valor.latitud}
                    longitud={valor.longitud}
                    pais={valor.pais}
                    ciudad={valor.ciudad}
                    key={valor.id}
                    fecha={fechaFormato.toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                      timeZone: "UTC",
                    })}
                    ubicacionmapa={() => {
                      ubicarAventuraenMapa(valor.longitud, valor.latitud);
                    }}
                    veraventura={() => {
                      navigate(
                        `/aventuras/${valor.id}/${valor.titulo
                          .replace(/\s+/g, "-")
                          .toLowerCase()}`
                      );
                    }}
                  />
                );
              })}
          </Box>
        </Grid>
        <Grid
          xs={0}
          md={7}
          sx={{
            height: "100%", // Hace que la columna ocupe toda la altura disponible
            padding: 0,
            borderRadius: "20px",
          }}
        >
          <Mapa
            sx={{ borderRadius: "12px" }}
            aventuras={aventuras}
            latitud={latitud}
            longitud={longitud}
            zoom={zoom}
          />
        </Grid>
      </Grid>
    </div>
  );
}
